import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  IProgram,
  IListProgramResponse,
  IListProgramsRequestBody,
  IProgramNamesResponse,
  IProgramCreateResponse,
  IProgramCreateRequest,
  IProgramUpdateRequest,
  IProgramUpdateResponse,
  IProgramDeleteResponse,
  IProgramStatusUpdateResponse,
} from '../../state/models/program.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProgramService {
  private readonly programBaseUrl = `${environment.programEndpoint}/api/program`;

  constructor(private readonly apiService: ApiService) {}

  createProgramManual(
    program: IProgramCreateRequest
  ): Promise<IProgramCreateResponse> {
    return this.apiService.post<IProgramCreateResponse>(
      `${this.programBaseUrl}/`,
      program
    );
  }
  createProgramAI(
    program: IProgramCreateRequest
  ): Promise<IProgramCreateResponse> {
    return this.apiService.post<IProgramCreateResponse>(
      `${this.programBaseUrl}/ai`,
      program
    );
  }

  getProgramById(id: number): Promise<{ data: IProgram }> {
    return this.apiService.get<{ data: IProgram }>(
      `${this.programBaseUrl}/${id}`
    );
  }

  listPrograms(
    body: IListProgramsRequestBody,
    page = 1,
    limit = 10
  ): Promise<IListProgramResponse> {
    return this.apiService.post<IListProgramResponse>(
      `${this.programBaseUrl}/list?page=${page}&limit=${limit}`,
      body
    );
  }

  listProgramNames(): Promise<IProgramNamesResponse> {
    return this.apiService.get<IProgramNamesResponse>(
      `${this.programBaseUrl}/get-programs-list/active`,
      {}
    );
  }

  listProgramNamesByClientIds(
    client_ids: string[]
  ): Promise<IProgramNamesResponse> {
    return this.apiService.post<IProgramNamesResponse>(
      `${this.programBaseUrl}/by-clients`,
      { client_ids }
    );
  }

  // disposition
    getProgramName_Client(
    client_id: string
  ): Promise<IProgramNamesResponse> {
    return this.apiService.post<IProgramNamesResponse>(
      `${this.programBaseUrl}/by-clients`,
      {client_ids: [client_id]}
    );
  }
  updateProgram(
    id: number,
    program: IProgramUpdateRequest
  ): Promise<IProgramUpdateResponse> {
    return this.apiService.put<IProgramUpdateResponse>(
      `${this.programBaseUrl}/${id}`,
      program
    );
  }

  updateAiProgram(
    id: number,
    program: IProgramUpdateRequest
  ): Promise<IProgramUpdateResponse> {
    return this.apiService.put<IProgramUpdateResponse>(
      `${this.programBaseUrl}/ai/${id}`,
      program
    );
  }

  deleteProgram(id: number): Promise<IProgramDeleteResponse> {
    return this.apiService.delete<IProgramDeleteResponse>(
      `${this.programBaseUrl}/${id}`
    );
  }

  changeProgramStatus(id: number): Promise<IProgramStatusUpdateResponse> {
    return this.apiService.patch<IProgramStatusUpdateResponse>(
      `${this.programBaseUrl}/${id}`,
      {}
    );
  }
}
